import { CreditCardIcon } from "@heroicons/react/20/solid";

export default function Billing({}) {
  // Fetch inboxes for this organization

  return (
    <div className="bg-white rounded-2xl ml-4 mr-2 mt-2 pb-16 pt-8 text-center">
      <CreditCardIcon className="w-16 text-gray-200 mx-auto" />
      <h1 className="text-center text-lg font-semibold text-gray-700">
        You're using the free beta version
      </h1>
      <p className="text-xs w-1/2 text-center mx-auto text-gray-500">
        We're currently not charging for the Rectangle platform. <br /> We'd
        appreciate your feedback and support while we improve the platform
      </p>
      <p className="font-semibold text-xs mt-4 text-gray-600">
        hi@rectanglelabs.ai
      </p>
      <div className="flex justify-center mt-4 space-x-2">
        <></>
      </div>
    </div>
  );
}
